import React, { Component } from 'react'
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { ToastContainer } from 'react-toastify';
import { Field, Form } from 'react-final-form';
import TextInput from '../../components/forms/TextInput';
import ButtonIcon from '../../components/commons/ButtonIcon';
import categoriesAction from "../../context/categories/actions"
import productsAction from "../../context/products/actions"
import ProductCard from '../../components/customs/ProductCard';
import config from "../../config"
import LayoutResponsiveWSmall from '../../components/layout/LayoutResponsiveWSmall';
import Icon from '../../libraries/icons';
import Loader from '../../components/commons/Loader';
class SearchProductsFavors extends Component {

  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      categories: [],
      filterApply: [],
      products: [],
      searchProducts:false
    }
  }
   getCategories = async (values = {}, label = '', filterIndex = null) => {
    const { name, parent } = values
    const filter = {
      enabled: 1,
      parent: "root",
      type: ["products", "favors"],
    }
    let newFilterApply = this.state.filterApply

    if (name) {
      filter.where = { custom: { name: `%${name}%` } }
    }

    if (parent) {
      filter.parent = parent
      if (filterIndex !== null) {
        newFilterApply = this.state.filterApply.slice(0, filterIndex + 1)
      } else {
        newFilterApply = [...this.state.filterApply, { label, id: parent }]
      }
      this.setState({ filterApply: newFilterApply })
    }
    await this.props.onGetAllCategories(filter)
    const error = this.props.categories.error
    if (error) {
      console.error(error)
    }
    const listCategories = this.props.categories.items
    this.setState({ categories: listCategories, searchProducts: false, products: [] })

    if (newFilterApply.length > 0 && listCategories.length < 1) {
      this.getProducts({ parent })
    }

  }

  getProducts = async (values = {}) => {
    const filter = {
      enabled: 1,
      type: ["products", "favors"],
    }

    await this.props.onGetAllProducts(filter)
    const error = this.props.products.error
    if (error) {
      console.error(error)
    }
    const listProducts = this.props?.products?.items?.filter(p => p.json_data?.category?.id == values.parent)
    this.setState({ products: listProducts,searchProducts:true })
  }

  resetFilter = () => {
    this.setState({ products: [], categories: [], filterApply: [] })
  }

  FilterApplyComponent = () => {
    return (
      <div className='flex gap-3 items-center bg-white mt-2 px-4 mb-4 py-3'>
        <ButtonIcon icon={"arrow_left"} className="w-6" buttonClassName={"bg-white text-primary border-none shadow-none p-1 text-xl"} />
        <div className='flex justify-between w-full' >
          <div className='flex'>
          {
            this.state.filterApply.map((f,ind)=>{
              const isLast= ind == this.state.filterApply.length -1 
              return(
                <span className='flex' onClick={()=>this.getCategories({parent:f.id}, '', ind)}>
                <p className={`hover:underline cursor-pointer ${isLast ? "font-bold":""}`}>{f.label}</p>
                {!isLast && <p>/</p>}
                </span>
              )
            })
          }
          </div>
          <button
            type='button'
            onClick={() => this.resetFilter()}
            className='flex items-center justify-center w-6 h-6 rounded-full bg-primary text-white'
          >
            x
          </button>
        </div>
      </div>
    )
  }

  render() {
    const { products } = this.state
    return (
      <LayoutResponsiveWSmall
        showSidebar={false}
        main={{ className: "" }}
        header={{
          title:"Buscar Productos/Favores",
          content: this.state.filterApply.length > 0 ? this.FilterApplyComponent() : <SearchComponent data={this.state.categories} fetchData={(value) => this.getCategories(value)} />
        }}
      >
        <ToastContainer />
        <div className='bg-white mt-2 px-4 mb-4 py-3'>
          <ul>
            {
              this.state.categories.map((cat,ind) => {
                return (
                  <li
                    key={ind + cat.name} 
                    className='hover:font-semibold border-b-2 py-3 mb-3 cursor-pointer' 
                    onClick={() => this.getCategories({ parent: cat.id }, cat.name)}
                  > 
                      {cat.name}
                  </li>
                )
              })
            }
          </ul>
          <div className="grid grid-cols-1 gap-4">
            {
              this.props.products.loading && <Loader/>
            }

            {products && products.map((product, index) => {
              return (
                <ProductCard
                  key={'p' + index}
                  route={{ pathname: config.ROUTES.PRODUCTS.DETAIL.replace(':id', product.id), state: { fromPath: config.ROUTES.SEARCH_OFFERS } }}
                  product={product}
                />
              )
            })
            }
            {
              products.length == 0 && this.state.searchProducts && (
                <div className='flex flex-col items-center gap-5 mt-5 text-neutral'>
                <Icon className="h-16 w-16" name="sad" />
                <p className="">{this.t("No hay productos/favores")}</p>
              </div>
              )
            }
          </div>
        </div>
      </LayoutResponsiveWSmall>
    )
  }
}

const mapStateToProps = state => {
  return {
    categories: state.categories.list,
    products: state.products.list
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onGetAllCategories: (params) => dispatch(categoriesAction.getAll(params)),
    onGetAllProducts: (params) => dispatch(productsAction.getAll(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(SearchProductsFavors));

class SearchComponent extends Component {
  constructor(props) {
    super(props)
    this.debounceTimer = null
  }

  handleInputChange = (value) => {
    clearTimeout(this.debounceTimer)
    this.debounceTimer = setTimeout(() => {
      this.props.fetchData(value ? { name: value } : {})
    }, 400)
  }

  render() {
    return (
      <div className='flex gap-3 px-3 py-2 bg-white'>
        <ButtonIcon icon={"arrow_left"} className="w-6" buttonClassName={"bg-white text-primary border-none shadow-none p-1 text-xl"} />
        <Form onSubmit={(value) => this.props.fetchData(value)}>
          {({ handleSubmit, form, submitting, pristine, values }) => {
            return (
              <form onSubmit={handleSubmit} className='w-full'>
                <div className='relative '>
                  <Field name="name">
                    {({ input, meta }) => (
                      <TextInput
                        input={{
                          ...input,
                          onChange: (e) => {
                            input.onChange(e)
                            this.handleInputChange(e.target.value)
                          }
                        }}
                        meta={meta}
                        placeholder="Producto/Favor"
                      />
                    )}
                  </Field>
                  {values.name?.length > 0 &&
                    <button
                      type='button'
                      onClick={() => {
                        form.reset()
                        clearTimeout(this.debounceTimer)
                        this.props.fetchData({})
                      }}
                      className='flex items-center justify-center absolute top-0 right-0 w-6 h-6 rounded-full bg-primary text-white'
                    >
                      x
                    </button>
                  }
                </div>
              </form>
            )
          }
          }
        </Form>
      </div>
    )
  }
}
